/**
 * Phase 2A bridge: re-export the One Up admin portal config so the legacy
 * apps/web shell can read branding, navigation, and module metadata from
 * apps/admin-oneup without taking a hard dependency on its file layout.
 */
import portalApp from '@command-center/admin-oneup';
import type { PortalAppConfig } from '@command-center/core-platform';

export const adminConfig: PortalAppConfig = portalApp.config;
export const adminApp = portalApp;
